import React, { useEffect, useState, useRef } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { useDispatch } from "react-redux";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import {
  salesCreditViewAction,
  salesInvoiceItemsGetAction,
  salesReturnItemsGetAction,
} from "../../../redux/actions/sales-action";
import CreateEditViewSalesCN from "../../../components/sales-section/sales-credit-note/create-edit-view-sales-CN";

const AddSalesCreditNote = () => {
  const { itemId, type } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const itemIdArray = JSON.parse(decodeURIComponent(itemId));

  //
  const cloneID = searchParams.get("cloneID");
  const isClone = cloneID ? true : false;
  //

  const allitems = itemIdArray.map((item) => {
    const { cmr_id, ...rest } = item;
    return rest;
  });
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isFormSaved, setIsFormSaved] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (isClone) {
      setLoading(true);
      dispatch(salesCreditViewAction(cloneID, onCloneSuccPur, onErrPur));
    } else if (type === "invoice") {
      setLoading(true);
      dispatch(salesInvoiceItemsGetAction(allitems, onSuccPur, onErrPur));
    } else if (type === "return") {
      setLoading(true);
      dispatch(salesReturnItemsGetAction(allitems, onSuccPur, onErrPur));
    }
  }, []);

  const onCloneSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };
  const onSuccPur = (data) => {
    setOrderDetail(data?.data);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };

  // Intercept ALL navigation methods (including back button)
  useEffect(() => {
    if (!hasUnsavedChanges) return;

    // Intercept link clicks
    // const handleLinkClick = (event) => {
    //   const target = event.target.closest("a[href]");
    //   if (target) {
    //     console.log("=== LINK CLICK INTERCEPTED ===");
    //     console.log("Link href:", target.href);
    //     console.log("Has unsaved changes:", hasUnsavedChanges);

    //     const shouldNavigate = window.confirm(
    //       "You have unsaved changes. Are you sure you want to navigate away without saving?"
    //     );

    //     if (shouldNavigate) {
    //       console.log("User confirmed link navigation - allowing");
    //       // Don't prevent default, allow navigation
    //     } else {
    //       console.log("User cancelled link navigation");
    //       event.preventDefault();
    //     }
    //     return false;
    //   }
    // };

    // Intercept back button clicks
    // const handleBackClick = (event) => {
    //   if (
    //     event.target.closest('button[aria-label="Back"]') ||
    //     event.target.closest('button[title*="Back"]') ||
    //     event.target.closest("button:has(svg)")
    //   ) {
    //     console.log("=== BACK BUTTON CLICKED ===");
    //     console.log("Has unsaved changes:", hasUnsavedChanges);

    //     const shouldNavigate = window.confirm(
    //       "You have unsaved changes. Are you sure you want to navigate away without saving?"
    //     );

    //     if (shouldNavigate) {
    //       console.log("User confirmed back navigation - allowing");
    //       navigate(-1);
    //     } else {
    //       console.log("User cancelled back navigation");
    //     }
    //     event.preventDefault();
    //     event.stopPropagation();
    //     return false;
    //   }
    // };

    // document.addEventListener("click", handleLinkClick, true);
    // document.addEventListener("click", handleBackClick, true);

    // return () => {
    //   document.removeEventListener("click", handleLinkClick, true);
    //   document.removeEventListener("click", handleBackClick, true);
    // };
  }, [hasUnsavedChanges, navigate]);

  // Block browser refresh/close when there are unsaved changes
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue =
          "You have unsaved changes. Are you sure you want to leave?";
        return "You have unsaved changes. Are you sure you want to leave?";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  const handleUnsavedChangesChange = (hasChanges) => {
    setHasUnsavedChanges(hasChanges);
  };

  const handleFormSaved = () => {
    setIsFormSaved(true);
    setHasUnsavedChanges(false);
  };

  const orderData = orderDetail?.orderData || {};
  const vendorDetails = orderDetail?.vendorDetails?.[0] || {};
  const isNew = searchParams.has("new");

  const prefix = searchParams.get("type") || "soit";
  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout
          backBtn={true}
          title={`${isClone ? "Clone" : "Add"} Sales Credit Note`}
        >
          <CreateEditViewSalesCN
            clickedplus={isNew}
            isClone={isClone}
            page="add"
            payto={
              isClone
                ? orderDetail?.orderData?.sct_pay_to_address
                : vendorDetails?.[`${prefix}_pay_to_address`]
            }
            shipto={
              isClone
                ? orderDetail?.orderData?.sct_ship_to_address
                : vendorDetails?.[`${prefix}_ship_to_address`]
            }
            pageType="credit note"
            type={type}
            orderDetail={orderDetail?.itemData}
            vendorDetails={
              isClone
                ? [orderDetail?.orderData]
                : [
                    {
                      ...vendorDetails,
                      sct_sub_total: orderData?.sub_total,
                      sct_total_gst: orderData?.total_tax,
                      sct_total_discount: orderData?.total_discount,
                      sct_total_amount: orderData?.total_amount,
                      sct_round_off_value: orderData?.round_off_value,
                      sct_tcs_or_tds_amount: orderData?.tcs_or_tds_amount,
                      sct_tcs_or_tds_percentage_id:
                        orderData?.tcs_or_tds_percentage_id,
                      sct_tcs_or_tds_percentage:
                        orderData?.tcs_or_tds_percentage,
                      sct_tds_tcs_type: orderData?.tcs_or_tds_type,
                      sct_is_invoice_dis_percentage:
                        orderData?.is_invoice_dis_percentage ?? true,
                      sct_invoice_discount: orderData?.invoice_discount ?? 0,
                      sct_invoice_discount_percentage:
                        orderData?.invoice_discount_percentage ?? 0,
                    },
                  ]
            }
            onUnsavedChangesChange={handleUnsavedChangesChange}
            onFormSaved={handleFormSaved}
            hasUnsavedChanges={hasUnsavedChanges}
            isFormSaved={isFormSaved}
          />
        </InnerLayout>
      )}
    </>
  );
};
export default AddSalesCreditNote;
